import { gql } from '@apollo/client'

export const LEGAL_NOTICE_EXPORT_MUTATION = gql`
  mutation LegalNoticeExport(
    $provider: String!
    $filters: [FilterInput!]
    $search: SearchInput
    $email: String
  ) {
    legalNoticeExport(
      provider: $provider
      filters: $filters
      search: $search
      email: $email
    ) {
      message
    }
  }
`
